export enum HWFeatureFlags {
    Placeholder = 'placeholder',
    MissingMetadataQueue = 'missing-metadata-queue',
    MetadataConfiguration = 'metadata-configuration',
    VmsDescriptions = 'vms-descriptions',
    ContractRequirementIsRequiredDiscrepancyTracking = 'contract-requirement-is-required-discrepancy-tracking',
    RequirementDiscrepancyTrackingMarkAsReviewed = 'requirement-discrepancy-tracking-mark-as-reviewed',
    NovaPendingDocumentsToggleText = 'nova-pending-documents-toggle-text',
    AutogeneratedEnvelopeBanner = 'autogenerated-envelope-banner',
    SendAutogeneratedEsignatureEnvelope = 'send-autogenerated-esignature-envelope',
    NovaDocusignEnvelopeAutosendConfigure = 'nova-docusign-envelope-autosend-configure',
    CalculatedExpirationDate = 'calculated-expiration-date',
    ValQueueFilterStateDocuments = 'val-queue-filter-state-documents',
    MetadataFormRefactorForFieldGroups = 'metadata-form-refactor-for-field-groups',
    MinMaxNumericMetadata = 'min-max-numeric-metadata',
    NumericMetadata = 'numeric-metadata',
    EnableUploadGridsIncludeMiddleName = 'enable-upload-grids-include-middle-name',
    ShowCRUpdatedRuleBuilderCFD = 'show-cr-updated-rule-builder-cfd',
    ValQueueRequirementNote = 'val-queue-requirement-note',
    ShowEditMetadataUpdatedRuleBuilderCFD = 'show-edit-metadata-updated-rule-builder-cfd',
    ExpirationImplementationSettings = 'expiration-implementation-settings',
    CfdWinningRulesetRtcrAutomatchFlyout = 'cfd-winning-ruleset-rtcr-automatch-flyout'
}
